import { Button, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface Props {
  title: string;
  description: string;
  buttonLabel: string;
  onButtonClick: () => void;
}

export const MessageCard = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
}: Props) => (
  <Card variant="outlined">
    <Title variant="subtitle1" fontWeight={600}>
      {title}
    </Title>
    <Description color="text.secondary">{description}</Description>
    <Button variant="outlined" onClick={onButtonClick}>
      {buttonLabel}
    </Button>
  </Card>
);

const Card = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  width: '100%',
  maxWidth: 480,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const Description = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
